/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Col_TypeInputs */

const vi_product_lot_history_col_type = /** @type {(inputs: Product_Lot_History_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

/**

* @param {Product_Lot_History_Col_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_col_type = /** @type {((inputs?: Product_Lot_History_Col_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Col_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_col_type(inputs)
});